import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useRef, useState } from 'react';
import { clsx } from 'clsx';
import ArrowIosRight from '@crehana/compass.icons.outline/ArrowIosRight';
import { Tooltip } from '@crehana/ui';
import { AuthUserRoleEnum } from "../../../generated/graphql/types";
import { handleNavigation } from "../../../shared/utils";
import DecoratedIcon from "./DecoratedIcon";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var MenuLink = function MenuLink(_ref) {
  var currentActive = _ref.currentActive,
    onClickItem = _ref.onClickItem,
    isDark = _ref.isDark,
    menuLink = _ref.menuLink,
    sidebarCollapsed = _ref.sidebarCollapsed,
    isFooterLink = _ref.isFooterLink,
    userRole = _ref.userRole,
    centralizedId = _ref.centralizedId;
  var icon = menuLink.icon,
    activeIcon = menuLink.activeIcon,
    decoratedIcon = menuLink.decoratedIcon;
  var Icon = activeIcon || icon;
  var popperRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  var isLinkActive = menuLink !== null && menuLink !== void 0 && menuLink.code && currentActive !== null && currentActive !== void 0 && currentActive.code ? currentActive === null || currentActive === void 0 ? void 0 : currentActive.code.includes(menuLink === null || menuLink === void 0 ? void 0 : menuLink.code) : false;
  var remarked = isHovered || isLinkActive;
  var textColor = remarked ? 'tw-text-primary-light-500 dark:tw-text-secondary-dark-300' : 'tw-text-neutral-light-700 dark:tw-text-neutral-dark-400';
  var iconColor = 'tw-text-primary-light-500 dark:tw-text-secondary-dark-300';
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("li", {
      className: clsx('tw-relative tw-block tw-w-full tw-py-0.4', {
        'tw-px-1.2': !isFooterLink
      }),
      ref: popperRef,
      children: /*#__PURE__*/_jsx(Tooltip, {
        label: menuLink.tooltip || menuLink.label,
        position: "right",
        isDark: !isDark,
        hidden: !sidebarCollapsed,
        children: /*#__PURE__*/_jsxs("button", {
          className: clsx('tw-flex tw-items-center tw-rounded-0.8 tw-cursor-pointer', !remarked && 'tw-bg-transparent', remarked && isLinkActive && 'tw-bg-neutral-dark-200 dark:tw-bg-elevation-dark-03', remarked && !isLinkActive && 'tw-bg-neutral-light-200 dark:tw-bg-elevation-dark-02', sidebarCollapsed ? 'tw-justify-center tw-w-4.8 tw-h-4.8 tw-mx-auto' : 'tw-p-0.8 tw-w-full', !decoratedIcon && 'tw-h-4'),
          onClick: function onClick() {
            if (onClickItem) {
              handleNavigation({
                url: menuLink.url || '',
                centralizedId: centralizedId || '',
                userRole: userRole || AuthUserRoleEnum.AuthRoleUser,
                onClickItem: onClickItem,
                openInNewTab: false
              });
            }
          },
          onMouseEnter: function onMouseEnter() {
            return setIsHovered(true);
          },
          onMouseLeave: function onMouseLeave() {
            return setIsHovered(false);
          },
          type: "button",
          children: [/*#__PURE__*/_jsx(_Fragment, {
            children: decoratedIcon ? /*#__PURE__*/_jsx(DecoratedIcon, {
              sidebarCollapsed: sidebarCollapsed,
              iconColor: iconColor,
              Icon: Icon
            }) : /*#__PURE__*/_jsx("div", {
              className: clsx('tw-flex tw-items-center tw-justify-center', !isFooterLink && ' tw-w-[28px] tw-h-[28px]', decoratedIcon && 'tw-border-solid tw-border-[0.5px] dark:tw-border-elevation-dark-04  tw-border-neutral-light-400'),
              children: /*#__PURE__*/_jsx(Icon, {
                size: sidebarCollapsed && !isFooterLink ? 20 : 16,
                className: clsx(textColor, 'tw-fill-current'),
                ignoreColor: true
              })
            })
          }), !sidebarCollapsed && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx("p", {
              className: clsx('tw-text-left tw-ml-0.8', isFooterLink ? 'tw-font-body5' : 'tw-font-subtitle5', textColor),
              children: menuLink.label
            }), menuLink.arrowDefault && /*#__PURE__*/_jsx(ArrowIosRight, {
              size: 20,
              className: clsx('tw-ml-auto', textColor)
            })]
          })]
        })
      })
    }, menuLink.label + menuLink.code)
  });
};
export default MenuLink;